/**
 * All analytics event names in one catalog.
 * Aligns with the GA4 onboarding event list.
 */
export const AnalyticsEvent = {
    SCREEN_VIEW: 'screen_view',
    TERMS_ACCEPTED: 'terms_accepted',
    REGISTRATION_FORM_SUBMITTED: 'registration_form_submitted',
    OTP_SENT: 'otp_sent',
    OTP_VERIFIED: 'otp_verified',
    OTP_FAILED: 'otp_failed',
    OTP_RESENT: 'otp_resent',
    OTP_EXPIRED: 'otp_expired',
    OTP_ATTEMPTS_EXCEEDED: 'otp_attempts_exceeded',
    VERIFICATION_METHOD_SELECTED: 'verification_method_selected',
    BIOMETRIC_VERIFICATION_STARTED: 'biometric_verification_started',
    BIOMETRIC_VERIFICATION_COMPLETED: 'biometric_verification_completed',
    BIOMETRIC_VERIFICATION_FAILED: 'biometric_verification_failed',
    CONTRACT_TERMS_ACCEPTED: 'contract_terms_accepted',
    CONTRACT_SIGNED: 'contract_signed',
    REGISTRATION_COMPLETED: 'registration_completed',
    REGISTRATION_FAILED: 'registration_failed',
    REGISTRATION_ABANDONED: 'registration_abandoned',
} as const;
